import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import http from "@/api/http";
import axios from "axios";
var TF_ENV = process.env.VUE_APP_TYPHOON; // const ecapi = process.env.VUE_APP_ECAPI

var ecapi = 'https://dcapi.istrongcloud.com/'; // const local = process.env.VUE_APP_LOCAL_BASE

var VUE_APP_FY_BASE = process.env.VUE_APP_FY_BASE;
export default {
  getTfGfs: function () {
    var _getTfGfs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var random, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              random = new Date().getTime();
              _context.next = 3;
              return http.getStaticData("".concat(TF_ENV, "data/gfs/gfs.json?random=").concat(random));

            case 3:
              res = _context.sent;
              return _context.abrupt("return", res.data);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getTfGfs() {
      return _getTfGfs.apply(this, arguments);
    }

    return getTfGfs;
  }(),
  getMenuImageInfo: function () {
    var _getMenuImageInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return http.getStaticData(url);

            case 2:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function getMenuImageInfo(_x) {
      return _getMenuImageInfo.apply(this, arguments);
    }

    return getMenuImageInfo;
  }(),
  getMenuImageInfo1: function () {
    var _getMenuImageInfo2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url) {
      var res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return axios.get('./test.json');

            case 2:
              res = _context3.sent;
              return _context3.abrupt("return", res.data);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function getMenuImageInfo1(_x2) {
      return _getMenuImageInfo2.apply(this, arguments);
    }

    return getMenuImageInfo1;
  }(),
  // 这个接口貌似没用
  getPressure: function () {
    var _getPressure = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var random, res;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              random = new Date().getTime();
              _context4.next = 3;
              return http.get("".concat(ecapi, "data/gfs/pressure?apiKey=gzqxgfs&random=").concat(random));

            case 3:
              res = _context4.sent;
              return _context4.abrupt("return", res.data);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function getPressure() {
      return _getPressure.apply(this, arguments);
    }

    return getPressure;
  }(),
  getTyphoonCompletion: function () {
    var _getTyphoonCompletion = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
      var random, res;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              random = new Date().getTime();
              _context5.next = 3;
              return http.getStaticData("".concat(TF_ENV, "data/completion/").concat(id, ".json?random=").concat(random));

            case 3:
              res = _context5.sent;
              return _context5.abrupt("return", res.data);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function getTyphoonCompletion(_x3) {
      return _getTyphoonCompletion.apply(this, arguments);
    }

    return getTyphoonCompletion;
  }(),
  getOceanLayersData: function () {
    var _getOceanLayersData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(time) {
      var random, res;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              random = new Date().getTime(); // let res = await axios.get(`http://api.readearth.com/dataapi/identity/ww3json?time=${time}&format=json`)

              _context6.next = 3;
              return http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/gfspython/wave.json?random=").concat(random));

            case 3:
              res = _context6.sent;
              return _context6.abrupt("return", res.data);

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function getOceanLayersData(_x4) {
      return _getOceanLayersData.apply(this, arguments);
    }

    return getOceanLayersData;
  }(),
  getTyphoonInfo: function () {
    var _getTyphoonInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var random, res;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              random = new Date().getTime();
              _context7.next = 3;
              return http.getStaticData("".concat(TF_ENV, "data/complex/currMerger.json?random=").concat(random));

            case 3:
              res = _context7.sent;
              return _context7.abrupt("return", res.data);

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function getTyphoonInfo() {
      return _getTyphoonInfo.apply(this, arguments);
    }

    return getTyphoonInfo;
  }(),
  // 获取历史年份信息
  getTyphoonYearList: function () {
    var _getTyphoonYearList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var random, res;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              random = new Date().getTime();
              _context8.next = 3;
              return http.getStaticData("".concat(TF_ENV, "data/complex/years.json?random=").concat(random));

            case 3:
              res = _context8.sent;
              return _context8.abrupt("return", res.data);

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function getTyphoonYearList() {
      return _getTyphoonYearList.apply(this, arguments);
    }

    return getTyphoonYearList;
  }(),
  // 获取当年台风列表
  getTyphoonPathNow: function () {
    var _getTyphoonPathNow = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var random, res;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              random = new Date().getTime();
              _context9.next = 3;
              return http.getStaticData("".concat(TF_ENV, "data/complex/path.json?random=").concat(random));

            case 3:
              res = _context9.sent;
              return _context9.abrupt("return", res.data);

            case 5:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function getTyphoonPathNow() {
      return _getTyphoonPathNow.apply(this, arguments);
    }

    return getTyphoonPathNow;
  }(),
  // 根据id获取路径信息
  getTyphoonPathByID: function () {
    var _getTyphoonPathByID = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
      var random, res;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              random = new Date().getTime();
              _context10.next = 3;
              return http.getStaticData("".concat(TF_ENV, "data/complex/").concat(id, ".json?random=").concat(random));

            case 3:
              res = _context10.sent;
              return _context10.abrupt("return", res.data);

            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function getTyphoonPathByID(_x5) {
      return _getTyphoonPathByID.apply(this, arguments);
    }

    return getTyphoonPathByID;
  }(),
  // 历史点包含预报点信息的数据
  getTyphoonIncludeForecast: function () {
    var _getTyphoonIncludeForecast = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
      var random, res;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              random = new Date().getTime();
              _context11.next = 3;
              return http.getStaticData("https://data.istrongcloud.com/v5/data/complex/".concat(id, ".json?random=").concat(random));

            case 3:
              res = _context11.sent;
              return _context11.abrupt("return", res.data);

            case 5:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function getTyphoonIncludeForecast(_x6) {
      return _getTyphoonIncludeForecast.apply(this, arguments);
    }

    return getTyphoonIncludeForecast;
  }(),
  // 获取副高预报数据文件
  // async getPressureForcastList() {
  //   const random = new Date().getTime()
  //   const res = await axios.get(`${VUE_APP_FY_BASE}/data/gfspython/time_fg.json`, {
  //     params: {
  //       random
  //     }
  //   })
  //   return res.data
  // },
  // 获取副高预报数据文件V2
  // async getPressureForcastList_V2() {
  //   const random = new Date().getTime()
  //   const res = await axios.get(`${VUE_APP_FY_BASE}/data/gfs/time_fg.json`, {
  //     params: {
  //       random
  //     }
  //   })
  //   return res.data
  // },
  getPressureForcastList_V3: function () {
    var _getPressureForcastList_V = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
      var random, res;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              random = new Date().getTime();
              _context12.next = 3;
              return http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/gfs24/time_fg.json?random=").concat(random));

            case 3:
              res = _context12.sent;
              return _context12.abrupt("return", res.data);

            case 5:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function getPressureForcastList_V3() {
      return _getPressureForcastList_V.apply(this, arguments);
    }

    return getPressureForcastList_V3;
  }(),
  // 获取副高具体内容
  getPressureByTime: function getPressureByTime(timeFilePath) {
    var random = new Date().getTime();
    var res = http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/gfs24/fgdata/").concat(timeFilePath, "?random=").concat(random));
    return res;
  },
  // 获取浪场预报数据文件
  // async getOceanForcastList() {
  //   const random = new Date().getTime()
  //   const res = await axios.get(`${VUE_APP_FY_BASE}/data/gfspython/time_wave.json`, {
  //     params: {
  //       random
  //     }
  //   })
  //   return res.data
  // },
  // async getOceanForcastList_V2() {
  //   const random = new Date().getTime()
  //   const res = await axios.get(`${VUE_APP_FY_BASE}/data/gfs/time_wave.json`, {
  //     params: {
  //       random
  //     }
  //   })
  //   return res.data
  // },
  getOceanForcastList_V3: function () {
    var _getOceanForcastList_V = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
      var random, res;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              random = new Date().getTime();
              _context13.next = 3;
              return http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/gfs24/time_wave.json?random=").concat(random));

            case 3:
              res = _context13.sent;
              return _context13.abrupt("return", res.data);

            case 5:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function getOceanForcastList_V3() {
      return _getOceanForcastList_V.apply(this, arguments);
    }

    return getOceanForcastList_V3;
  }(),
  // 获取浪场具体内容
  getOceanByTime: function getOceanByTime(timeFilePath) {
    var random = new Date().getTime();
    var res = http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/gfs24/wavedata/").concat(timeFilePath, "?random=").concat(random));
    return res;
  },
  // 获取风场预报数据
  // async getWindFieldForcastList() {
  //   const random = new Date().getTime()
  //   const res = await axios.get(`${VUE_APP_FY_BASE}/data/gfspython/time_fc.json`, {
  //     params: {
  //       random
  //     }
  //   })
  //   return res.data
  // },
  // async getWindFieldForcastList_V2() {
  //   const random = new Date().getTime()
  //   const res = await axios.get(`${VUE_APP_FY_BASE}/data/gfs/time_fc.json`, {
  //     params: {
  //       random
  //     }
  //   })
  //   return res.data
  // },
  getWindFieldForcastList_V3: function () {
    var _getWindFieldForcastList_V = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
      var random, res;
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              random = new Date().getTime();
              _context14.next = 3;
              return http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/gfs24/time_fc.json?random=").concat(random));

            case 3:
              res = _context14.sent;
              return _context14.abrupt("return", res.data);

            case 5:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    function getWindFieldForcastList_V3() {
      return _getWindFieldForcastList_V.apply(this, arguments);
    }

    return getWindFieldForcastList_V3;
  }(),
  // 获取风场具体数据，没在使用
  getWindByTime: function getWindByTime(timeFilePath) {
    var random = new Date().getTime();
    var res = http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/gfs24/fcdata/").concat(timeFilePath, "?random=").concat(random));
    return res;
  },
  // 根据台风编号获取概率圈数据
  getProbabilityByTfbh: function () {
    var _getProbabilityByTfbh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(id) {
      var random, res;
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              random = new Date().getTime();
              _context15.next = 4;
              return http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/contour/").concat(id, ".json?random=").concat(random));

            case 4:
              res = _context15.sent;
              return _context15.abrupt("return", res.data);

            case 8:
              _context15.prev = 8;
              _context15.t0 = _context15["catch"](0);
              return _context15.abrupt("return", false);

            case 11:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[0, 8]]);
    }));

    function getProbabilityByTfbh(_x7) {
      return _getProbabilityByTfbh.apply(this, arguments);
    }

    return getProbabilityByTfbh;
  }()
};